import React, { useEffect } from "react";
import Amplitude from "amplitude-js";
import Router from "./router/router";
import "./styles/styles.css";
import "./App.css";
import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";
import { store, persistor } from "./store/ConfigureStore";
import { QueryClient, QueryClientProvider } from "react-query";
import {ThemeProvider, createTheme} from '@mui/material/styles';
import "react-datepicker/dist/react-datepicker.css";



const queryClient = new QueryClient();

function App() {
  useEffect(() => {
    const ampInstance = Amplitude.getInstance();

    const connectionString = "7fa9fbbec98a958e2a18cb6e6acf58a2";

    ampInstance.init(connectionString);
  }, []);

  const theme = createTheme({
    shape: {
      borderRadius: 18, 
    },
    palette: {
      primary: {
        main: '#E3031F',
      },
      secondary: {
        main: '#020202',
      },
    },
    typography: {
      allVariants: {
        textTransform: "none"
      }
    },
    "overrides": {
      MuiSvgIcon: {
        colorPrimary: {
          color: ["#000", "!important"],
        },
        colorSecondary: {
          color: ["#d5d7d8", "!important"],
        },
      },
    }
  });


  return (
    <QueryClientProvider client={queryClient}>
       <ThemeProvider theme={theme}>
        <Provider store={store}>
          <PersistGate persistor={persistor}>
            <Router />
          </PersistGate>
        </Provider>
      </ThemeProvider>
    </QueryClientProvider>
  );
}

export default App;
